import React from 'react';

import Mentions, { MentionProps } from 'antd/lib/mentions';

import { Chat } from '@common/react/objects/Chat';

import '@common/react/scss/components/typingComponent.scss';
import { request } from '@common/react/components/Api';
import {
	ChatComponents,
	ChatFormComponentsDictionary,
	useChatSettingsProviderContext
} from '@common/react/components/Chat/ChatSettingsProvider';

export interface CustomMentionProps extends MentionProps {
	chat: Chat;
	prefix?: string;
}

const MentionsWithTyping: React.FC<CustomMentionProps> = ({chat, prefix = '', ...props}) => {
	const lastTyping = React.useRef<number | undefined>();
	const context = useChatSettingsProviderContext();

	if (!context?.state) throw 'need ChatSettingsContext';

	const {state: {otherComponents, requests, typingDelay: delay}} = context;

	const render = React.useCallback((contacts) => {
		const res = contacts.map(contact => `${contact.firstName} ${contact.lastName}`).join(', ');

		return <div className="tag-chat__typings-container">
			{!!contacts.length && <div className="tag-chat__typing">
				{`${res} ${contacts.length > 1 ? ' are typing' : ' is typing'}`}
			</div>}
		</div>;
	}, []);

	const keyDownHandler = React.useCallback((e: React.KeyboardEvent<HTMLTextAreaElement>) => {
		const k = e.which;

		if (48 <= k && k <= 90 && chat) {
			const typingDate = Date.now();
			if ((!lastTyping.current || (typingDate - lastTyping.current > delay))) {
				lastTyping.current = typingDate;

				request(requests.typing, {chatId: chat.id})
					.then((result) => {
					})
					.catch(console.log);
			}
		}

		props.onKeyDown && props.onKeyDown(e);
	}, [props.onKeyDown]);

	const typingComponent = otherComponents.includes(ChatComponents.Typing) ?
		ChatFormComponentsDictionary[ChatComponents.Typing]({chat, render, delay}) : undefined;

	return <>
		<Mentions
			{...props}
			onKeyDown={keyDownHandler}
		/>
		{typingComponent}
	</>;
};

export default MentionsWithTyping;
